import React from 'react';
import styled from 'styled-components';
import Layout from '../layout/Layout';
import { MobileHeaderType } from '../layout/ConfigurableMobileHeader';

interface PageTemplateProps {
  children: React.ReactNode;
  title?: string;
  hideHeaderOnMobile?: boolean;
  hideSidebarOnMobile?: boolean;
  hideBottomNavOnMobile?: boolean;
  // Legacy approach - custom component
  customMobileHeader?: React.ReactNode;
  // New approach - configurable header
  mobileHeaderType?: MobileHeaderType;
  mobileHeaderTitle?: string;
  showBackButton?: boolean;
  backPath?: string;
  transparentHeader?: boolean;
}

const PageWrapper = styled.div`
  background-color: #131314;
  min-height: 100vh;
  width: 100%;
  padding: 24px;
`;

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;

const PageHeader = styled.div`
  margin-bottom: 32px;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

const PageContent = styled.div`
  width: 100%;
`;

const PageTemplate: React.FC<PageTemplateProps> = ({ 
  children, 
  title,
  hideHeaderOnMobile = false,
  hideSidebarOnMobile = false,
  hideBottomNavOnMobile = false,
  customMobileHeader = null,
  mobileHeaderType,
  mobileHeaderTitle,
  showBackButton = false,
  backPath,
  transparentHeader = false
}) => {
  // Special layout for mobile-specific pages
  if (hideHeaderOnMobile || hideSidebarOnMobile || hideBottomNavOnMobile || customMobileHeader ||
      mobileHeaderType || mobileHeaderTitle || showBackButton || backPath || transparentHeader) {
    return (
      <Layout 
        hideHeaderOnMobile={hideHeaderOnMobile}
        hideSidebarOnMobile={hideSidebarOnMobile}
        hideBottomNavOnMobile={hideBottomNavOnMobile}
        customMobileHeader={customMobileHeader}
        mobileHeaderType={mobileHeaderType}
        mobileHeaderTitle={mobileHeaderTitle}
        showBackButton={showBackButton}
        backPath={backPath}
        transparentHeader={transparentHeader}
      >
        <PageWrapper>
          <PageContainer>
            {title && (
              <PageHeader>
                <PageTitle>{title}</PageTitle>
              </PageHeader>
            )}
            <PageContent>
              {children}
            </PageContent>
          </PageContainer>
        </PageWrapper>
      </Layout>
    );
  }
  
  // Default layout
  return (
    <PageWrapper>
      <PageContainer>
        {title && (
          <PageHeader>
            <PageTitle>{title}</PageTitle>
          </PageHeader>
        )}
        <PageContent>
          {children}
        </PageContent>
      </PageContainer>
    </PageWrapper>
  );
};

export default PageTemplate;
